import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { isAuthenticated } from "../../../../services/auth";
import { Tooltip, message, Card, Avatar, Button, Dropdown, Menu } from "antd";
import moment from "moment";
import "moment/locale/pt-br";
import {
  singleProduct,
  addFavourite,
  removeFavourite,
  closeProduct,
  favouriteCount,
} from "../../../../services/product";
import { Modal } from "antd";
import ReportProduct from "../../../../components/product/reportProduct";
import ProductComments from "../../../../components/product/productComments";
import { viewUser } from "../../../../services/user";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import RelatedProducts from "../../list/RelatedProduct";
import { useDispatch } from "react-redux";
import "./ViewProduct.css";

const { confirm } = Modal;
moment.locale("pt-br");

const API = process.env.REACT_APP_API.replace("/api", "");

const ViewProduct = ({ match, history }) => {
  const dispatch = useDispatch();

  const [product, setProduct] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [productLocation, setProductLocation] = useState([]);
  const [productAuthor, setProductAuthor] = useState([]);
  const [productAuthorName, setProductAuthorName] = useState([]);
  const [productReports, setProductReports] = useState([]);
  const [reported, setReported] = useState(false);
  const [category, setCategory] = useState("");
  const [favourites, setFavourites] = useState([]);
  const [favourite, setFavourite] = useState(false);
  const [favCount, setFavCount] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const { user, token } = isAuthenticated();

  useEffect(() => {
    loadProduct();
    loadUser();
    loadFavouriteCount();

    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        import('./ViewProductMobile.css');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // initial check

    return () => window.removeEventListener('resize', handleResize);
  }, [favourite, reported, match.params.productId]);

  const loadUser = async () => {
    if (user && token) {
      const res = await viewUser(user._id);
      setFavourites(res.data.favourites);
    }
  };

  const loadProduct = async () => {
    // Fetch product, include auth token to get private fields for owner
    const res = await singleProduct(match.params.productId, token);
    if (res.data) {
      setProduct(res.data);
      if (res.data.category) {
        setCategory(res.data.category);
      } else {
        setCategory({ name: "Categoria desconhecida", _id: "" });
      }
      if (res.data.location) {
        setProductLocation(res.data.location);
      } else {
        setProductLocation({ name: "Localização desconhecida", _id: "" });
      }
      if (res.data.author) {
        setProductAuthor(res.data.author);
        setProductAuthorName(res.data.author.name);
      } else {
        setProductAuthor(null);
        setProductAuthorName("Usuário desconhecido");
      }
      // Corrija aqui: monte a URL completa para cada imagem
      var imageArray = res.data.images.slice(0).map((item, index) => ({
        original: `${API}${item}`,
        thumbnail: `${API}${item}`,
      }));
      setProductImages(imageArray);

      const reportArray = [];
      res.data.reports.map((item) => reportArray.push(item.author));
      setProductReports(reportArray);
      dispatch({
        type: "PRODUCT_DETAILS",
        payload: res.data.category,
      });
    } else {
      // Handle case where product not found or error
      setProduct({
        name: "Produto não encontrado",
        _id: "",
        price: 0,
        description: "",
        condition: "",
        status: "",
        createdAt: null,
        updatedAt: null,
        privateObservation: "",
        privatePhone: "",
      });
      setCategory({ name: "Categoria desconhecida", _id: "" });
      setProductLocation({ name: "Localização desconhecida", _id: "" });
      setProductAuthor(null);
      setProductAuthorName("Usuário desconhecido");
      setProductImages([]);
      setProductReports([]);
    }
  };

  const loadFavouriteCount = async () => {
    const res = await favouriteCount(match.params.productId);
    setFavCount(res.data);
  };

  const handleAddFavourite = async (productId) => {
    const res = await addFavourite(productId, { user, token });
    console.log(res.data);
    message.success("Adicionado aos Favoritos");
    setFavourite(!favourite);
  };
  const handleRemoveFavourite = async (productId) => {
    const res = await removeFavourite(productId, { user, token });
    console.log(res.data);
    setFavourite(!favourite);
  };

  const handleCloseProduct = async (productId) => {
    try {
      await closeProduct(productId);
      message.success("Produto marcado como vendido!");
      loadProduct();
    } catch (err) {
      message.error("Erro ao marcar como vendido");
    }
  };

  //format currency
  Number.prototype.format = function (n, x) {
    var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&,");
  };

  const translateCondition = (condition) => {
    switch (condition) {
      case "New":
        return "Novo";
      case "Used":
        return "Usado";
      case "not_applicable":
        return "Não aplicável";
      default:
        return condition;
    }
  };

  const translateStatus = (status) => {
    switch (status) {
      case "active":
        return "Ativo";
      case "inactive":
        return "Inativo";
      case "pending":
        return "Pendente";
      default:
        return status;
    }
  };
  const renderAuthorCard = () => (
    <div className="author-card">
      <div className="product-header-sidebar">
        <h3 className="product-name-sidebar">{product.name}</h3>
        <span className="product-price-sidebar">
          {product && typeof product.price === "number"
            ? product.price.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
            : "R$ 0,00"}
        </span>
      </div>

      <div className="seller-info">
        <p className="seller-label">Vendedor</p>
        <div className="author-avatar">
          {productAuthor && productAuthor.photo ? (
            <Avatar
              src={`${process.env.REACT_APP_API.replace(
                /\/api$/,
                ""
              )}${productAuthor.photo}`}
              size={60}
            >
              {productAuthorName[0]}
            </Avatar>
          ) : (
            <Avatar
              size={60}
              style={{
                backgroundColor: "#e0e7ff",
                color: "#3730a3",
              }}
            >
              {productAuthorName[0]}
            </Avatar>
          )}
        </div>
        <div className="author-info">
          {productAuthor ? (
            <Link to={`/user/${productAuthor._id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <h4>{productAuthorName}</h4>
            </Link>
          ) : (
            <h4>{productAuthorName}</h4>
          )}
        </div>
      </div>
      {productAuthor && productAuthor.phone && (
        <a
          href={`https://wa.me/55${productAuthor.phone.replace(
            /\D/g,
            ""
          )}?text=Me%20interessei%20neste%20produto:%20${window.location.href
            }`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-link"
        >
          <i className="fab fa-whatsapp"></i> {productAuthor.phone}
        </a>
      )}

      <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
        <Button
          style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => {
            navigator.clipboard.writeText(window.location.href);
            message.success('Link copiado!');
          }}
        >
          <i className="fas fa-copy" style={{ marginRight: '8px' }}></i> Copiar Link
        </Button>

        <Button
          block
          style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={async () => {
            const textToCopy = `${product.name}\n\nVeja os detalhes aqui:\n${window.location.href}`;
            navigator.clipboard.writeText(textToCopy);
            message.success('Link copiado na área de transferência (é só colar)!');

            let shareData = {
              title: product.name,
              text: textToCopy,
            };

            try {
              if (productImages && productImages.length > 0) {
                const maxImages = Math.min(productImages.length, 6);
                const fetchPromises = [];
                for (let i = 0; i < maxImages; i++) {
                  fetchPromises.push(
                    fetch(productImages[i].original)
                      .then(res => res.blob())
                      .then(blob => new File([blob], `produto_${i + 1}.jpg`, { type: blob.type || 'image/jpeg' }))
                      .catch(e => null) // Ignora falhas individuais
                  );
                }
                const fetchedFiles = (await Promise.all(fetchPromises)).filter(f => f !== null);

                if (fetchedFiles.length > 0 && navigator.canShare && navigator.canShare({ files: fetchedFiles })) {
                  shareData.files = fetchedFiles;
                }
              }

              if (navigator.share) {
                await navigator.share(shareData);
              }
            } catch (err) {
              console.log('Erro ao compartilhar:', err);
              // Fallback
              if (navigator.share) {
                try {
                  await navigator.share({ title: product.name, url: window.location.href });
                } catch (fallbackErr) { }
              }
            }
          }}
        >
          <i className="fas fa-share-alt" style={{ marginRight: '8px' }}></i> Compartilhar
        </Button>
      </div>
      {user && productAuthor && user._id !== productAuthor._id && (
        <div className="author-actions">
          <Link to={`/user/${productAuthor._id}`}>
            <Button type="primary" block>
              Ver Perfil
            </Button>
          </Link>
        </div>
      )}
    </div>
  );

  const renderPrivateInfo = () => {
    if (!user || !productAuthor || user._id !== productAuthor._id) return null;

    let parsedPrivateObs = {};
    let legacyObs = (product && product.privateObservation) || '';
    let isJson = false;

    try {
      if (legacyObs.trim().startsWith('{')) {
        parsedPrivateObs = JSON.parse(legacyObs);
        legacyObs = parsedPrivateObs.legacyObs || '';
        isJson = true;
      }
    } catch (e) { }

    return (
      <div className="author-card" style={{ marginTop: '20px' }}>
        <h4 style={{ fontSize: '18px', borderBottom: '1px solid #eaeaea', paddingBottom: '10px', marginBottom: '15px' }}>
          <i className="fas fa-lock me-2" style={{ color: '#6b7280' }}></i>
          Informações Privadas
        </h4>
        {isJson ? (
          <div className="private-info-details" style={{ fontSize: '14px', lineHeight: '1.6' }}>
            <p><strong>Proprietário:</strong> {parsedPrivateObs.ownerName}</p>
            {parsedPrivateObs.ownerCpf && <p><strong>CPF:</strong> {parsedPrivateObs.ownerCpf}</p>}
            <p><strong>Endereço:</strong> {parsedPrivateObs.ownerAddress}</p>
            <p><strong>Telefone:</strong> {parsedPrivateObs.ownerPhone}</p>
            {parsedPrivateObs.ownerWhatsapp && (
              <p>
                <strong>WhatsApp:</strong>{' '}
                <a
                  href={`https://wa.me/55${parsedPrivateObs.ownerWhatsapp.replace(/\D/g, '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-link"
                >
                  <i className="fab fa-whatsapp" style={{ color: '#25D366' }}></i> {parsedPrivateObs.ownerWhatsapp}
                </a>
              </p>
            )}
            {legacyObs && (
              <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px dashed #eaeaea' }}>
                <strong>Observação Legado:</strong>
                <p>{legacyObs}</p>
              </div>
            )}
          </div>
        ) : (
          <div className="private-info-details">
            <p><strong>Observação:</strong> {legacyObs || 'Nenhuma'}</p>
            {product && product.privatePhone && (
              <Button
                type="primary"
                icon={<i className="fab fa-whatsapp"></i>}
                style={{ backgroundColor: '#25D366', borderColor: '#25D366', marginTop: '10px' }}
                onClick={() =>
                  window.open(`https://wa.me/55${product.privatePhone.replace(/\D/g, "")}`, "_blank")
                }
              >
                WhatsApp
              </Button>
            )}
          </div>
        )}

        {product.status !== 'closed' && (
          <Button
            type="primary"
            danger
            block
            style={{ marginTop: '15px' }}
            onClick={() => {
              confirm({
                className: 'centered-confirm-modal',
                title: 'Marcar como Vendido',
                content: 'Tem certeza que deseja marcar este produto como vendido?',
                okText: 'Sim',
                cancelText: 'Não',
                onOk() {
                  handleCloseProduct(product._id);
                },
              });
            }}
          >
            <i className="fas fa-check-circle me-2"></i> Marcar como Vendido
          </Button>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="view-product-container">
        <div className="view-product-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/" className="text-decoration-none">
                Início
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/category/${category._id}`}
                className="text-decoration-none"
              >
                {category.name}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{product.name}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="view-product-top-row">
          <div>
            <div className='view-product-gallery'>
              <ImageGallery
                items={productImages}
                showPlayButton={false}
                showFullscreenButton={false}
              />
            </div>
            <div className="view-product-main">
              {isMobile && renderAuthorCard()}
              {isMobile && renderPrivateInfo()}
              <div className="view-product-info">
                <div className="view-product-details">
                  <div className="detail-row">
                    <span className="detail-label">Categoria:</span>
                    <span className="detail-value">{category.name}</span>
                  </div>
                  {product && product.condition !== "" && (
                    <div className="detail-row">
                      <span className="detail-label">Condição:</span>
                      <span className="detail-value">
                        {translateCondition(product.condition)}
                      </span>
                    </div>
                  )}
                  <div className="detail-row">
                    <span className="detail-label">Status:</span>
                    <span className="detail-value">
                      {translateStatus(product.status)}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Localização:</span>
                    <Link
                      to={`/search-result?&location=${productLocation._id}&category=&name=&price=&condition=`}
                      className="detail-link"
                    >
                      {productLocation.name}
                    </Link>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Anunciado:</span>
                    <span className="detail-value">
                      {product
                        ? moment(product.createdAt).fromNow()
                        : "Carregando..."}
                    </span>
                  </div>
                  {product && product.updatedAt && (
                    <div className="detail-row">
                      <span className="detail-label">Atualizado:</span>
                      <span className="detail-value">
                        {moment(product.updatedAt).fromNow()}
                      </span>
                    </div>
                  )}
                </div>

                <div className="view-product-description">
                  <h3>Descrição</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: product.description
                        ? product.description.replace(/\n/g, "<br />")
                        : "",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="view-product-sidebar">
            {!isMobile && renderAuthorCard()}
            {!isMobile && renderPrivateInfo()}

            {user &&
              token &&
              product &&
              productAuthor &&
              user._id !== productAuthor._id && (
                <ReportProduct
                  product={product}
                  productReports={productReports}
                  productId={match.params.productId}
                  setReported={setReported}
                />
              )}

            {process.env.REACT_APP_ENABLE_USER_REGISTRATION !== 'false' && !isMobile && <ProductComments productId={match.params.productId} />}
          </div>
        </div>

        {process.env.REACT_APP_ENABLE_USER_REGISTRATION !== 'false' && isMobile && <ProductComments productId={match.params.productId} />}

        {product && product._id && <RelatedProducts productId={product._id} />}
      </div>
    </>
  );
};

export default ViewProduct;
